<template>
  <div>
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
        v-if="showQuery"
    >
      <el-form-item prop="orderCode" :label="$t('orderCode')+'：'">
        <order-drop v-model="queryForm.orderCode" size="mini"></order-drop>
      </el-form-item>
      <el-form-item prop="customerId" label="客户">
        <customer v-model="queryForm.customerId"></customer>
      </el-form-item>
      <el-form-item prop="batchCode" :label="$t('batchCode')+'：'">
        <el-input
            v-model="queryForm.batchCode"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productCode" :label="$t('productCode')+'：'">
        <el-input
            v-model="queryForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" :label="$t('skuCode')+'：'">
        <el-input
            v-model="queryForm.skuCode"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="$t('productName')+'：'">
        <el-input
            v-model="queryForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" :label="$t('nameZh')+'：'">
        <el-input
            v-model="queryForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>

      <el-form-item prop="productColor" :label="$t('productColor')+'：'">
        <el-input
            v-model="queryForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" :label="$t('productSize')+'：'">
        <el-input
            v-model="queryForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sellerName" :label="$t('sellerName')+'：'">
        <el-input
            v-model="queryForm.sellerName"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item label="" label-width="0">
        <el-checkbox v-model="showPriceDetail">显示费用明细</el-checkbox>
      </el-form-item>
      <el-form-item label="" label-width="0">
        <el-checkbox v-model="queryForm.showCompletedOrder">包含已结束合同</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="margin-bottom: 0;justify-content: flex-start;" v-if="showTool">
      <el-button type="warning" size="mini" v-if="$hasPermission('erp:make:company:send')" @click="showSendDialog">
        发货
      </el-button>
      <el-button type="warning" size="mini" v-if="$hasPermission('erp:make:company:send')"
                 @click="showSendImportDialog">
        发货导入
      </el-button>
      <el-button type="warning" size="mini" v-if="$hasPermission('erp:make:company:send')"
                 @click="showMakePriceAuditDialog">
        费用调整审核
      </el-button>
      <div style="display: flex;">
        <el-tooltip class="item" effect="dark" placement="right">
          <div slot="content">1.工厂发货数:工厂生产出来的配件/成品发到港口或其他工厂的数量<br/>2.工厂收货数:其他工厂发到该工厂的成品/配件,第一道工序或只有一道工序的时候该数一般为0<br/>3.箱单发货数：出口发票或销售开票录入的发货数量
          </div>
          <i class="el-icon-info" style="font-size: 14px;cursor: pointer;margin-left: 10px;">说明</i>
        </el-tooltip>
        <color-tip>工厂提交的费用调整待审核</color-tip>
      </div>
    </div>
    <SweetTable ref="table" :height="height" url="/erp/make/detail/page" :is-page="isPage" api-version="v2"
                :before-table-binding="beforeTableBinding" :query-form="queryForm" :selection="selection"
                :row-style="rowStyleHandler"
                :summaries-column="['count','totalPrice','receiveCount']"
                :auto-load="autoLoad" :before-load="beforeLoad" :default-query-params="defaultQueryParams">
      <el-table-column :label="$t('orderCode')" prop="orderCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px"
                       v-if="hideColumns.indexOf('orderCode')===-1"></el-table-column>
      <el-table-column label="客户" prop="customerName" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px"
                       v-if="hideColumns.indexOf('customerName')===-1"></el-table-column>
      <el-table-column :label="$t('batchCode')" prop="batchCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="120px"></el-table-column>
      <el-table-column label="品番信息" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <ProductRowCard :product="scope.row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <!--      <el-table-column label="SKU" prop="product.skuCode" header-align="center" align="center" fixed="left"-->
      <!--                       :show-overflow-tooltip="true">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          label="颜色"-->
      <!--          prop="product.color"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--          :show-overflow-tooltip="true"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          label="规格"-->
      <!--          prop="product.size"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--          :show-overflow-tooltip="true"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="sellerName"
          :label="$t('sellerName')"
          header-align="center"
          align="center"
          width="160" :formatter="$c.companyNameFormatter" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="sendCount"
          label="工厂发货"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="saleCount"
          label="出口发货数"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>

      <el-table-column
          label="加工费"
          header-align="center"
          align="center"
          prop="amount"
          width="90"
          v-if="showPriceDetail"
      >
      </el-table-column>
      <el-table-column
          label="包装检品费"
          header-align="center"
          align="center"
          prop="checkAmount"
          width="100"
          v-if="showPriceDetail"
      >
      </el-table-column>
      <el-table-column
          label="纸箱"
          header-align="center"
          align="center"
          prop="packPrice"
          width="90"
          v-if="showPriceDetail"
      >
      </el-table-column>
      <el-table-column
          label="中棉"
          header-align="center"
          align="center"
          prop="cottonPrice"
          width="90"
          v-if="showPriceDetail"
      >
      </el-table-column>
      <el-table-column
          label="运费"
          header-align="center"
          align="center"
          prop="freightPrice"
          width="90"
          v-if="showPriceDetail"
      >
      </el-table-column>
      <el-table-column
          label="综合单价"
          header-align="center"
          align="center"
          prop="totalPrice"
          width="90"
      >
      </el-table-column>
      <el-table-column
          label="加工费金额(已发货)"
          header-align="center"
          align="center"
          prop="totalAmount"
          width="90"
      >
      </el-table-column>
    </SweetTable>
    <ProductSendDialog ref="ProductSendDialog" @change="getDataList"></ProductSendDialog>
    <SendImportDialog ref="SendImportDialog" @change="getDataList"></SendImportDialog>
    <MakePriceAuditDialog ref="makePriceAuditDialog" @change="getDataList"></MakePriceAuditDialog>
  </div>
</template>

<script>
import MakePriceAuditDialog from '@/views/modules/erp/make/make-price-audit-dialog.vue'
import SendImportDialog from '@/views/modules/erp/make/send-import-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import moment from 'moment/moment'
import ProductSendDialog from '@/components/ProductSendDialog.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'
import BigNumber from 'bignumber.js'

/**
 * 加工单明细通用表格
 */
export default {
  name: 'make-detail-table',
  mixins: [SweetTable],
  components: { ProductSendDialog, SendImportDialog, MakePriceAuditDialog, ProductRowCard },
  props: {
    showTool: {
      type: Boolean,
      default: true
    },
    hideColumns: {
      type: Array,
      default: () => []
    },
    selection: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: null
    },
    isPage: {
      type: Boolean,
      default: true
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
      }
    },
    beforeLoad: {
      type: Function,
      default: null
    },
    showQuery: {
      type: Boolean,
      default: true
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    priceDetail: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    priceDetail: {
      handler (newVal) {
        this.showPriceDetail = newVal
      },
      immediate: true,
    },
    queryForm: {
      handler (val) {
        this.reload()
      },
      deep: true
    }
  },
  data () {
    return {
      showCompletedOrder: false,
      showPriceDetail: false,
      queryForm: {
        customerId: null,
        showCompletedOrder: false,
        orderCode: null,
        batchCode: null,
        productCode: null,
        productSkuCode: null,
        productName: null,
        productNameZh: null,
        productColor: null,
        productSize: null,
        sellerId: null,
        sellerName: null,
      }
    }
  },
  methods: {
    rowStyleHandler ({ row, rowIndex }) {
      if (row.auditId != null) {
        return { color: '#a400a2' }
      }
    },
    showSendImportDialog () {
      this.$refs.SendImportDialog.init()
    },
    showMakePriceAuditDialog () {
      let selData = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(selData)) {
        return this.$message.error('请选择要审核的数据')
      }
      selData = selData.filter(item => item.auditId != null)
      if (this.$c.isArrayEmpty(selData)) {
        return this.$message.error('没有待审核的数据')
      }
      let dataList = selData.map(item => {
        return {
          id: item.id,
          orderCode: item.orderCode,
          product: item.product,
          planCount: item.count,
          amount: item.amount,
          checkAmount: item.checkAmount,
          packPrice: item.packPrice,
          cottonPrice: item.cottonPrice,
          freightPrice: item.freightPrice,
          auditParams: item.auditParams,
          auditId: item.auditId
        }
      })
      this.$refs.makePriceAuditDialog.init(dataList)
    },
    showSendDialog () {
      let selData = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(selData)) {
        return this.$message.error('请选择要发货的订单记录')
      }
      let sendData = selData.map(item => {
        return {
          sourceId: item.id,
          makeDetailId: item.id,
          planCount: item.count,
          totalPrice: item.totalPrice,
          makeType: item.makeType,
          product: item.product,
          orderCode: item.orderCode,
          senderId: item.sellerId,
          sellerName: item.sellerName,
          receiverName: item.receiverName,
          totalSendCount: item.receiveCount,
          operateTime: moment().format('YYYY-MM-DD')
        }
      })
      this.$refs.ProductSendDialog.init(sendData)
    },
    beforeTableBinding (dataList) {

    }
  }
}
</script>

<style scoped>

</style>
